module.exports = __webpack_public_path__ + "static/img/autumn_hetaoPic.30b3a273.png";